import React, { useEffect, useRef } from "react";
import Chart from "chart.js";

Chart.defaults.RoundedDoughnut = Chart.helpers.clone(Chart.defaults.doughnut);

Chart.controllers.RoundedDoughnut = Chart.controllers.doughnut.extend({
  draw: function (ease) {
    const ctx = this.chart.ctx;
    const easingDecimal = ease || 1;
    const arcs = this.getMeta().data;

    Chart.helpers.each(arcs, function (arc, i) {
      arc.transition(easingDecimal).draw();

      const pArc = arcs[i === 0 ? arcs.length - 1 : i - 1];
      const pColor = pArc._view.backgroundColor;

      const vm = arc._view;
      const radius = (vm.outerRadius + vm.innerRadius) / 2;
      const thickness = (vm.outerRadius - vm.innerRadius) / 2;
      const startAngle = Math.PI - vm.startAngle - Math.PI / 2;
      const angle = Math.PI - vm.endAngle - Math.PI / 2;

      ctx.save();
      ctx.translate(vm.x, vm.y);

      ctx.fillStyle = i === 0 ? vm.backgroundColor : pColor;
      ctx.beginPath();
      ctx.arc(
        radius * Math.sin(startAngle),
        radius * Math.cos(startAngle),
        thickness,
        0,
        2 * Math.PI
      );
      ctx.fill();

      ctx.fillStyle = vm.backgroundColor;
      ctx.beginPath();
      ctx.arc(
        radius * Math.sin(angle),
        radius * Math.cos(angle),
        thickness,
        0,
        2 * Math.PI
      );
      ctx.fill();

      ctx.restore();
    });
  },
});

const MyChart = (props) => {
  console.log("chart data props", props);
  const chartRef = useRef(null);

  // const filteredData = props.chartData.data.filter((value) => value !== 0);

  useEffect(() => {
    // if (props.chartData.data.length === 0) {
    //   return;
    // }

    const chart = new Chart(chartRef.current, {
      type: "RoundedDoughnut",
      data: {
        labels: [
          "Fast Start Commission",
          "Team Sales Commission",
          "Group Sales Rebate",
          "Retail Profit Bonus",
        ],
        datasets: [
          {
            data: props.data.data,
            backgroundColor: props.data.options,
            borderWidth: 0,
          },
        ],
      },
      options: {
        cutoutPercentage: 70,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 10,
          },
        },
        responsive: true, // Make the chart responsive
        maintainAspectRatio: false,
        resizeDelay: 10000,
        height: 400, // Prevent the chart from maintaining aspect ratio
      },
    });

    return () => {
      chart.destroy();
    };
  }, [props.data]);

  return (
    <canvas
      ref={chartRef}
      style={{ width: "100%", height: "100%", maxWidth: "100%" }}
      id="myChart"
    /> // Set the chart canvas width and height to 100%
  );
};

export default MyChart;
